import { createStyles, TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import colors from 'styles/colors';

export const StyledTableRow = withStyles(() =>
  createStyles({
    root: {
      textAlign: 'left',
      cursor: 'pointer',
      color: colors.gray[600],
      '&:hover': {
        backgroundColor: colors.gray[100]
      }
    }
  })
)(TableRow);
